const assesmentSteps = [
  {
    link: '/assesment',
    name: 'UPLOAD FILES'
  },
  {
    link: '/runassesment/',
    name: 'RUN ASSESSMENT'
  },
  {
    link: '/viewReport',
    name: 'VIEW REPORT'
  },
  {
    link: '/requestTrans',
    name: 'REQUEST TRANSLATION'
  }
];

export default assesmentSteps;



// WEBPACK FOOTER //
// ./src/data/assesment-steps.js